
import { DeleteIcon, EllipsisVertical, Upload } from "lucide-react";
import { ListFilter, Search } from "lucide-react";
import { Button } from "../ui/button";
import { IoIosAdd } from "react-icons/io";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Input } from "../ui/input";
import {
    Card,
    CardContent,
} from "../ui/card";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../table/table";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "../ui/tabs";
import { useEffect, useState } from "react";
import DeleteConfirmationDialog from "../ui/deleteConfirmationDialog";
import DialogBox from "../ui/deleteConfirmationDialog";

function SchemeTable({ onRowClick = () => {},totalPage,buttonOptions,currentPage,setCurrentPage,schemeListData, showNewSchemaForm ,columns}) {
    const[searchTerm,setSearchTerm]=useState("")
    const [previousFocus, setPreviousFocus] = useState(null);

     const [isOpenDeleteUserConfirmation,setIsOpenDeleteUserConfirmation]=useState(false)
    
     const [selectedItem, setSelectedItem] = useState(null);

     const handleDeleteConfirmation = (item) => {
  
      setSelectedItem(item); // Set the selected item
      setIsOpenDeleteUserConfirmation(true); // Open the dialog
    };
    
    const handleCloseDeleteUserConfirmation=()=>{
      console.log("set is open ",isOpenDeleteUserConfirmation)
      setSelectedItem(null)
      
      setIsOpenDeleteUserConfirmation(false)
      console.log("document.active",document.activeElement)

    }

    const [filteredSchemes,setFilteredSchemes] = useState([])
    const handlePageChange = (page) => {
      const setPageIndex=page-1
      setCurrentPage(setPageIndex); // Update pageIndex based on selected page
    };


    

    const handleDeleteConfirm = async () => {
      if (!selectedItem) return;
    
      buttonOptions[2].actionHandleDeleteScheme({scheme_id:selectedItem.scheme_id,scheme_name:selectedItem?.scheme_name,scheme_class:selectedItem?.scheme_class})
 
      setTimeout(() => {
        setIsOpenDeleteUserConfirmation(false)
      }, 1000);
    
    };

  useEffect(()=>{
  console.log(searchTerm)
  if(searchTerm.length>0){
    setFilteredSchemes(schemeListData.filter((scheme) => {
      const search = searchTerm.toLowerCase();
      return (
          scheme.scheme_name.toLowerCase().includes(search) ||
          scheme.scheme_class.toLowerCase().includes(search) 
          
      );
  }))
  }
  else{
    setFilteredSchemes(schemeListData)
  }
  console.log("schemeListData",schemeListData)
  },[searchTerm,schemeListData])
  return (
        <>
            <div className="w-full flex justify-between items-start p-2">
                <div className="flex w-full justify-end items-center gap-4">

                    {/* Add Scheme Button */}
                    <Button variant="outline" onClick={showNewSchemaForm} size="sm" className="h-7 gap-1 text-sm">
                        <IoIosAdd />
                        <span className="sr-only sm:not-sr-only">Add Scheme</span>
                    </Button>


                    {/* Search Bar */}
                    <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                        <Search className="h-8 w-6 text-muted-foreground" />
                        <Input
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e)=>setSearchTerm(e.target.value)}
                            className="rounded-none border-none focus:ring-0 text-lg"
                        />
                    </div>

                    {/* Dropdown Menu */}
                    {/* <div className="flex items-center gap-2">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    className="h-7 gap-1 text-sm"
                                >
                                    <ListFilter className="h-3.5 w-3.5" />
                                    <span className="sr-only sm:not-sr-only">Filter</span>
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                                <DropdownMenuSeparator />
                                <DropdownMenuCheckboxItem checked>
                                    Fulfilled
                                </DropdownMenuCheckboxItem>
                                <DropdownMenuCheckboxItem>Declined</DropdownMenuCheckboxItem>
                                <DropdownMenuCheckboxItem>Refunded</DropdownMenuCheckboxItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div> */}
                </div>
            </div>

            <Card x-chunk="dashboard-05-chunk-3">
                <CardContent>
                <Table>
        <TableHeader>
          <TableRow   >
          {buttonOptions?.length > 0 && (
              <TableHead className="w-[6%] text-left">Actions</TableHead>
            )}
            <TableHead className="" >Sr No.</TableHead>
            {columns?.map((column, index) => (
              <TableHead key={index} className="" >{column.header}</TableHead>
            ))}
            {/* Conditionally render the "Actions" column if buttonOptions are provided */}
            
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredSchemes?.map((item, rowIndex) => (
            <TableRow key={rowIndex} onClick={() => onRowClick(rowIndex)}>
               {buttonOptions?.length > 0 && (
                <TableCell className="w-[6%] text-left">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <EllipsisVertical className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      {buttonOptions.map((option, index) => (
                        <div key={index}>
                          <DropdownMenuItem>
                            <Button
                              variant="none"
                              className="flex items-center px-2 gap-4 h-6 text-sm"

                              onClick={()=>{
                               if(option.name==="View"){
                                return option.actionHandleViewScheme({scheme_id:item.scheme_id,scheme_name:item?.scheme_name,scheme_class:item?.scheme_class})
                               }
                               if(option.name==="Delete"){
                                // setSelectedItem(item)
                                return handleDeleteConfirmation(item)
                                // return option.actionHandleDeleteScheme({scheme_id:item.scheme_id,scheme_name:item?.scheme_name,scheme_class:item?.scheme_class})

                               }
                               if(option.name==="Edit"){
                                return option.actionHandleEditScheme({scheme_id:item.scheme_id,scheme_name:item?.scheme_name,scheme_class:item?.scheme_class})
                               }
                              }}

                            >
                              {option.icon}
                              <span>{option.text}</span>
                            </Button>
                          </DropdownMenuItem>
                          {index < buttonOptions.length - 1 && (
                            <DropdownMenuSeparator />
                          )}
                        </div>
                      ))}
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              )}
              <TableCell>{rowIndex + 1}</TableCell>
              {columns.map((header, colIndex) => (
                <TableCell key={colIndex} className="flex-grow">
                  {item[header.id]}
                </TableCell>
              ))}
              {/* Conditionally render the action buttons if buttonOptions exist */}
             
            </TableRow>
          ))}
        </TableBody>
      </Table>
    
                </CardContent>
               
            </Card>
            <div className="flex justify-end items-center mt-4">
          
          <div>
                <span>
                  Page{" "}
                  <strong>
                    
                    {currentPage}
                     of{" "}
                    {totalPage}
                  </strong>{" "}
                </span>
                <select
                  value={currentPage+1}
                  onChange={(e) => handlePageChange(Number(e.target.value))}
                  className="p-2 border border-gray-300 rounded ml-2"
                >
                 {Array.from({ length: totalPage }, (_, index) => index +1).map((page) => (
                    <option key={page} value={page+1}>
                      Page {page}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* <DeleteConfirmationDialog
        isOpen={isOpenDeleteUserConfirmation}
        onClose={handleCloseDeleteUserConfirmation}
        onConfirm={handleDeleteConfirm}
        title={`Delete Scheme`}
        description={`Are you sure you want to delete ${selectedItem?.scheme_name} and ${selectedItem?.scheme_class}, this Scheme? This action cannot be undone.`}

        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      /> */}

<DialogBox
        isOpen={isOpenDeleteUserConfirmation}
        onClose={handleCloseDeleteUserConfirmation}
        title="Delete Confirmation"
        message={`Are you sure you want to delete this ${selectedItem?.scheme_name}-${selectedItem?.scheme_class} Scheme ? This action cannot be undone.`}
       onConfirm={handleDeleteConfirm}
      />
        </>
    )
}

export default SchemeTable